import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { CodeConversionMstDto, WorkResultArea } from 'sg-api';
import { TimeApiService } from 'cbc-shared-lib';

@Component({
  selector: 'app-sgke360d-results',
  templateUrl: './sgke360d-results.component.html',
  styleUrl: './sgke360d-results.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke360dResultsComponent implements OnInit, OnDestroy {
  @Input() workResultArea: WorkResultArea;
  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;
  /** 作業結果ラジオボタン */
  get actionTypeSagyokekka(): string {
    return this.getControl('supplystopresumptionResultDivcd').value ?? '0';
  };

  /** 登録日 */
  get regDate(): Date{
    return this.timeApiService.convertStringToDate(this.workResultArea.regDate);
  }

  /** 親フォームグループ */
  public parentForm: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {CodeConversionMstService} codeConvert
   * @memberof Sgke360dResultsComponent
   */
  constructor(
    private parent: FormGroupDirective,
    public timeApiService: TimeApiService,
  ) {
  }

  // 初期化処理
  ngOnInit(): void {
    // 親フォームを参照
    this.parentForm = this.parent.form.get('supplyresumptionResultInfo') as UntypedFormGroup;
  }

  /**
   * 終了処理
   *
   * @memberof Sgke360dResultsComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * フォームコントロール取得
   * @param ctlname コントロール名
   * @returns フォームコントロール
   */
  getControl(ctlname: string): FormControl {
    return this.parentForm?.get(ctlname) as FormControl;
  }


}
